import React from 'react';

import GlobalStyles from './styles/GlobalStyles';

import Layout from './components/Layout';

function App() {
  return (
    <>
      <GlobalStyles />
      <Layout />
    </>
  );
}

export default App;
